import firebase from "firebase/app";
import "firebase/storage";
import { FIREBASE_CONFIG } from "../config/firebase";
import "@firebase/messaging";
firebase.initializeApp({
  apiKey: "AIzaSyAF2JfURa5hFr6Ust1LWf1xvJ0--5IF8E4",
  authDomain: "masspa-dev.firebaseapp.com",
  databaseURL: "https://masspa-dev.firebaseio.com",
  projectId: "masspa-dev",
  storageBucket: "masspa-dev.appspot.com",
  messagingSenderId: "995477577303",
  appId: "1:995477577303:web:0e5f4a5ae33eb3d4ce0d12",
});

const storageRef = firebase.storage().ref();

export const _firebase = firebase;

export const listAllFiles = async ({ serviceCode, folder }) => {
  try {
    const root = `myServices/${serviceCode}/album/`;
    const listRef = storageRef.child(root + folder);
    const response = await listRef.listAll();
    const folders = getProperties({
      listRefs: response.prefixes,
      type: "folder",
      root,
    });
    const files = getProperties({
      listRefs: response.items,
      type: "file",
      root,
    });

    return [...folders, ...files];
  } catch (error) {
    console.log(error);
  }
};

export const getProperties = ({ listRefs, type, root }) => {
  return listRefs.map((ref) => {
    return {
      path: ref.fullPath.replace(root, ""),
      name: ref.name,
      type,
    };
  });
};

export const getMetadata = (ref) => {
  return ref
    .getMetadata()
    .then((metadata) => {
      return metadata;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
};

export const requestPermission = () => {
  return Notification.requestPermission()
    .then((permission) => {
      if (permission === "granted") {
        console.log("NOTIFICATION PERMISSION GRANTED.");
        return true;
      } else {
        console.log("UNABLE TO GET PERMISSION TO NOTIFY.");
        return false;
      }
    })
    .catch((error) => {
      console.warn("GET TOKEN ERROR", error);
      return null;
    });
};

export const getToken = async () => {
  try {
    const fcmToken = await firebase
      .messaging()
      .getToken({ vapidKey: FIREBASE_CONFIG.publicVapidKey });
    if (fcmToken) {
      return fcmToken;
    }
    return null;
  } catch (error) {
    console.warn("GET TOKEN ERROR", error);
    return null;
  }
};
